const TypingIndicator = () => (
  <div className="flex items-center gap-1 p-2">
    <div className="w-2 h-2 bg-[#C9B896] rounded-full animate-pulse-dot" style={{ animationDelay: '0ms' }}></div>
    <div className="w-2 h-2 bg-[#C9B896] rounded-full animate-pulse-dot" style={{ animationDelay: '200ms' }}></div>
    <div className="w-2 h-2 bg-[#C9B896] rounded-full animate-pulse-dot" style={{ animationDelay: '400ms' }}></div>
  </div>
);

export default TypingIndicator;
